import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-perfect-scrollbar/dist/css/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/app/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/iconify-icons/generated-icons.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppInsightsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FetchInterceptorInit"] */ "/app/src/components/FetchInterceptorInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LangRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/theme/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextAuthProvider"] */ "/app/src/contexts/nextAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/styles/AppReactToastify.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/redux-store/ReduxProvider.tsx");
